import { useEffect } from "react";

/** Usage
 * Custom hook to auto-refetch data if it's stale.
 * Compares the current time to `lastFetched` and calls `fetchAction`
 * if the data is older than the provided `ttl` (time-to-live, in ms).
 * Runs only once on mount — useful for cache freshness on page load.
 */

interface Props {
  lastFetched: number; // Date
  ttl: number; // milliseconds
  fetchAction: () => void; // Can be fetch or any function
}

// Automatically refresh cached data if it's stale (based on TTL)
export const useRefetchWithTTL = ({
  lastFetched = 0,
  ttl,
  fetchAction,
}: Props) => {
  useEffect(() => {
    const now = Date.now();

    if (!lastFetched || now - lastFetched > ttl) {
      fetchAction();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
